import React, { Component, useState, } from 'react';
import { Box, Grid, makeStyles, Typography, Hidden, Container, } from '@material-ui/core'
import "./landingPage.css"
import Video from "./video"
import bitRank from "../../media/bitRank.png"
import bitRankVerified from "../../media/bitbank-verified.svg"
import training from "../../media/training.svg"
import qlue from "../../media/qlue.png"
import forensic from "../../media/forensic.svg"
import qluesvg from "../../media/qlue.svg"
import ImgLawEnforcement from "../../media/ImgLawEnforcement.jpg"
import bigLogoDark from "../../media/bigLogoDark.svg"
import ScrollAnimation from 'react-animate-on-scroll';
const useStyles = makeStyles((theme) => ({

  darkBlue: {
    color: theme.colors.blue,
    fontFamily: theme.font.fontFamily,
    fontWeight: 700,
    marginBottom: "20px",
    [theme.breakpoints.down("md")]: {
      marginBottom: "15px",
      fontSize: "1rem",
      fontWeight: 600,
      textAlign: "justify"
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: ".9rem",
      fontWeight: 500,
      textAlign: "justify"
    }
  },
  lightBlue: {
    color: theme.colors.lightBlue,
    fontFamily: theme.font.fontFamily,
    fontWeight: 700,
    marginBottom: "20px",
    [theme.breakpoints.down]: {
      fontWeight: 600,
      fontSize: "1rem",
      textAlign: "justify"
    },
    [theme.breakpoints.down("sm")]: {
      fontWeight: 600,
      fontSize: ".9rem",
      textAlign: "justify"

    },

  },
  lightBlueHeading: {
    color: theme.colors.lightBlue,
    fontFamily: theme.font.fontFamily,
    fontWeight: 700,
    marginBottom: "20px",

    [theme.breakpoints.down("md")]: {
      fontWeight: 600,
      fontSize: "2rem",
      marginBottom: "15px",

    },
    [theme.breakpoints.down("md")]: {
      fontWeight: 600,
      fontSize: "1.5rem",
      marginBottom: "10px",

    }
  },

  box1: {
    justifyContent: "center",
    alignItems: "center",
    marginTop: "50px"
  },
  box2: {
    justifyContent: "center",
    alignItems: "center",
  },
  recentNews: {
    border: "2px solid blue",
    padding: "1rem",
    maxWidth: "808px",
    height: "20rem",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "10rem",
      marginLeft: "-1rem"
    }
  },
  recentNewsText: {
    backgroundColor: "white",
    color: theme.colors.blue,
    fontFamily: theme.font.fontFamily,
    fontWeight: 700,
    padding: "10px",
    right: "2%",
    top: "-20px",
    [theme.breakpoints.down("sm")]: {
      bottom: "-10px",
      right: "2%",
      top: "92%",

    }
  },
  recentNewsText1: {
    marginLeft: "200px",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",

    }

  },
  darkGrayBox: {
    backgroundColor: theme.colors.darkGray,
    height: "220px",
    padding: "20px !important",
    borderRadius: "5px",
    margin: "10px",
    [theme.breakpoints.down("md")]: {
      height: "auto",
    }
  },
  white: {
    color: theme.colors.white,
    fontFamily: theme.font.fontFamily,
  },
  imgContainer: {
    width: "100%",
    [theme.breakpoints.down("md")]: {

      paddingLeft: ".5rem",

    }
  },
  boxText: {
    color: theme.colors.white,
    fontFamily: theme.font.fontFamily,
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem"
    }
  },
  lastnewsBox: {
    padding: "2rem",
    [theme.breakpoints.down("md")]: {
      padding: "0rem",
    }
  }

}));

function Main() {
  const classes = useStyles();
  return (
    <div>
      {/* video */}
      <div>   <Video /></div>
      {/* about us */}

      <Container maxWidth="lg" >
        <Grid container className={classes.box1} >
          <Grid item xs={12} container className={classes.box1} >
            {/* box1 */}
            <Grid item xs={10} sm={8} className={classes.box2}>
              <ScrollAnimation animateIn="zoomIn">
                <Typography variant="h3" className={classes.lightBlueHeading} >ABOUT US</Typography>
                <Typography variant="h5" className={classes.darkBlue} >Whether you’re in Law Enforcement, the Financial Sector, or you’re a Regulator, we specialize in the forensic investigation and risk mitigation you need to catch criminals and be compliant.</Typography>
                <Typography variant="body1" className={classes.lightBlue} >Our clients rely on our tools and our team’s seasoned investigators to make sure their wallet / transaction risk scores and forensic investigation insights give them the information they need. It makes a significant difference to have a team led by a former Homeland Security Investigations Special Agent.</Typography>
              </ScrollAnimation>
            </Grid>
            {/* box2 */}
            <Grid item container direction="row-reverse" className={classes.box1} xs={12} spacing={2}>
              <Grid className={classes.box2} item container xs={12} sm={12} md={5}>
                <ScrollAnimation animateIn="zoomIn">
                  <img src={bitRankVerified} alt="" className={classes.imgContainer} />
                </ScrollAnimation>
              </Grid>
              <Grid item xs={10} sm={8} className={classes.box2} md={7}>
                <Grid className={classes.box2} item container xs={12}>
                  <ScrollAnimation animateIn="zoomIn">
                    <img src={bitRank} alt="" className={classes.imgContainer} />
                  </ScrollAnimation>
                </Grid>
                <ScrollAnimation animateIn="zoomIn">
                  <Typography variant="h5" className={classes.darkBlue} >AML, CTF, KYC and OFAC compliance regulations require you to manage the risk of cryptocurrency transactions?</Typography>
                  <Typography variant="body1" className={classes.lightBlue} >Our BitRank Verified® "risk-scoring" service gives you a reassuring, easy-to-understand safety ranking of the wallet and/or transaction.</Typography>
                </ScrollAnimation>
              </Grid>
            </Grid>

            <Grid item container className={classes.box1} xs={12} spacing={2} >
              <Grid className={classes.box2} item container xs={12} sm={12} md={5}>
                <ScrollAnimation animateIn="zoomIn">
                  <img src={training} alt="" className={classes.imgContainer} />
                </ScrollAnimation>
              </Grid>
              <Grid item xs={10} sm={8} className={classes.box2} md={7}>
                <Grid className={classes.box2} item container xs={12}>
                  <ScrollAnimation animateIn="zoomIn">
                    <img src={qlue} alt="" className={classes.imgContainer} />
                  </ScrollAnimation>
                </Grid>
                <ScrollAnimation animateIn="zoomIn">
                  <Typography variant="h5" className={classes.darkBlue} >Fighting terrorist financing, money laundering, human trafficking, drug trafficking, weapons trafficking, or other cyber crimes?</Typography>
                  <Typography variant="body1" className={classes.lightBlue} >QLUE™ enables investigators to quickly and visually "follow the virtual money" behind Bitcoin and Ethereum transactions.</Typography>
                </ScrollAnimation>
              </Grid>
            </Grid>
            <Grid item container direction="row-reverse" className={classes.box1} xs={12} spacing={2}>
              <Grid className={classes.box2} item container xs={12} sm={12} md={5}>
                <ScrollAnimation animateIn="zoomIn">
                  <img src={forensic} alt="" className={classes.imgContainer} />
                </ScrollAnimation>
              </Grid>
              <Grid item xs={10} sm={8} className={classes.box2} md={7}>
                <ScrollAnimation animateIn="zoomIn">
                  <Typography variant="h4" className={classes.darkBlue} >Forensic Services Division</Typography>
                  <Typography variant="h5" className={classes.darkBlue} >Facing security issues that require expert-level forensic investigation efforts?</Typography>
                  <Typography variant="body1" className={classes.lightBlue} >Our in-house team of expert investigators deliver hands-on forensic investigation services you need to support regulatory compliance and gain maximum insight into nefarious cryptocurrency activities.</Typography>
                </ScrollAnimation>
              </Grid>
            </Grid>
            <Grid item container className={classes.box1} xs={12} spacing={2}>
              <Grid className={classes.box2} item container xs={12} sm={12} md={5}>
                <ScrollAnimation animateIn="zoomIn" >
                  <img src={qluesvg} alt="" className={classes.imgContainer} />
                </ScrollAnimation>
              </Grid>
              <Grid item xs={10} sm={8} className={classes.box2} md={7}>
                <ScrollAnimation animateIn="zoomIn">
                  <Typography variant="h4" className={classes.darkBlue} >Expert Training</Typography>
                  <Typography variant="h5" className={classes.darkBlue} >Need your team to develop the ability to understand cryptocurrency and successfully investigate suspicious activities?</Typography>
                  <Typography variant="body1" className={classes.lightBlue} >Our flexible on-site and online training options get you up to speed in a fraction of the time it would take on your own.</Typography>
                </ScrollAnimation>
              </Grid>
            </Grid>
            <Grid item container direction="row-reverse" className={classes.box1} xs={12} >
              <Hidden mdUp>
                <Grid className={classes.box2} item container xs={12} sm={12} md={5}>
                  <ScrollAnimation animateIn="zoomIn">
                    <img src={ImgLawEnforcement} alt="" width="400px" height="250px" className={classes.imgContainer} />
                  </ScrollAnimation>
                </Grid>

                <Grid item xs={10} sm={8} className={classes.box2} style={{ padding: "1rem" }} >
                  <ScrollAnimation animateIn="zoomIn">
                    <Box className={classes.recentNews} position="relative"  >
                      <Box position="absolute" className={classes.recentNewsText} >RECENT NEWS</Box>
                      <Typography ml="100px" variant="h5" className={classes.recentNewsText1 + " " + classes.darkBlue} >BIG Blockchain Intelligence Group is First to Launch Fee-Based, 8-Hour Cryptocurrency Investigator Certification Course</Typography>
                    </Box>
                  </ScrollAnimation>
                </Grid>
              </Hidden>
              <Hidden smDown>
                <ScrollAnimation animateIn="zoomIn">
                  <Box className={classes.recentNews} position="relative"  >
                    <Box position="absolute" left={-100} top="30%" >
                      <ScrollAnimation animateIn="zoomIn">
                        <img src={ImgLawEnforcement} alt="" width="300px" height="150px" />
                      </ScrollAnimation>
                    </Box>
                    <Box position="absolute" className={classes.recentNewsText} >RECENT NEWS</Box>
                    <Typography ml="100px" variant="h5" className={classes.recentNewsText1 + " " + classes.darkBlue} >BIG Blockchain Intelligence Group is First to Launch Fee-Based, 8-Hour Cryptocurrency Investigator Certification Course</Typography>
                  </Box>
                </ScrollAnimation>
              </Hidden>
            </Grid>
            <ScrollAnimation animateIn="zoomIn">
              <Grid item container className={classes.box1} xs={12} >
                <Grid className={classes.darkGrayBox} item xs={12} sm={6} md={4} >
                  <Typography variant="body2" className={classes.boxText}  >IN THE NEWS</Typography>
                  <Typography variant="h6" className={classes.boxText}  >Product Feature: Artificial Intelligence Breaking into Law Enforcement</Typography>
                </Grid>
                <Grid className={classes.darkGrayBox} item xs={12} sm={6} md={4} >
                  <Typography variant="body2" className={classes.boxText}  >IN THE NEWS</Typography>
                  <Typography variant="h6" className={classes.boxText}  >Lance Morginn: Blockchain explained for businesses, law enforcement and students</Typography>
                </Grid>
                <Grid item container xs={12} sm={6} md={3} className={classes.lastnewsBox}>
                  <Grid item >
                    <img src={bigLogoDark} alt="" width="120px" height="120px" className={classes.imgContainer} />
                  </Grid>
                  <Grid item>
                    <Typography variant="body1" className={classes.darkBlue}  >Blockchain Intelligence Group</Typography>
                    <Typography variant="body1" className={classes.darkBlue}  >Vancouver, BC, Canada <br /> Texas, USA <br /> Zug (Crypto Valley), Switzerland</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </ScrollAnimation>

          </Grid>
        </Grid>
      </Container>


    </div>
  );
}

export default Main;


